export const get_domain = (name, chainId, contract) => ({
  name,
  version: "1",
  chainId,
  verifyingContract: contract,
});

export const constantContractMethods = Object.freeze({
  whitelistMinting: "whiteListMinting",
  lazyminting: "lazyMinting",
  listNft: "listNft",
  cancelorder: "cancelOrder",
  placebid: "placeBid",
  cancelbid: "cancelBid",
  acceptbid: "acceptBid",
  buynft : "buyNft",
  withdraw : "withDraw",
  transfernft : "transferNft",
  burn: "burnNft",
  bulkmint : "bulkMint"
});

export const get_types = {
  [constantContractMethods.whitelistMinting]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTBalance", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.lazyminting]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTBalance", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.listNft]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTId", type: "uint256" },
      { name: "ListedQuantity", type: "string" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.cancelorder]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTId", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.placebid]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTQuantity", type: "uint256" },
      { name: "bidderAddress", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.cancelbid]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "bidderAddress", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.acceptbid]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "bidderAddress", type: "address" },
      { name: "NFTQuantity", type: "uint256" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.buynft]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "NFTQuantity", type: "uint256" },
      { name: "buyerAddress", type: "address" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.withdraw]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "NFTQuantity", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.transfernft]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "NewOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.burn]: {
    NFTData: [
      { name: "NFTId", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
  [constantContractMethods.bulkmint]: {
    NFTData: [
      { name: "TokenName", type: "string" },
      { name: "NFTBalance", type: "uint256" },
      { name: "NFTOwner", type: "address" },
      { name: "deadline", type: "uint256" },
      { name: "salt", type: "uint256" },
    ],
  },
};
